import Header from 'components/headers/funds'
import useGetTransactions from './hooks/useGetTransactions'
import SideBar from 'components/sidebar'
import SideBarItems from 'components/sidebar/items'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useCallback } from 'react'

export default function TransactionsPage() {
    const { data, isLoading, fetchNextPage } = useGetTransactions()
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])
    return (
        <>
            <Header title="تراکنش ها" />
            <SideBar>
                <SideBarItems />
            </SideBar>
            <div className=" flex justify-between w-full px-4 mt-4 mb-2 text-sm text-gray-1">
                <p>طرف حساب</p>
                <p>تاریخ و مبلغ</p>
            </div>
            <InfiniteScroll
                hasMore={
                    data
                        ? data?.pages[data.pages.length - 1].next
                            ? true
                            : false
                        : false
                }
                next={onWatchEnd}
                dataLength={
                    data ? data.pages.flatMap((x) => x.results).length : 0
                }
                loader={<DotsLoading />}
            >
                <>
                    {!isLoading && data ? (
                        data.pages
                            .flatMap((x) => x.results)
                            .map((item, index) => (
                                <div key={index}>
                                    {/* {item.destination !== 'hpl' && ( */}
                                    <Item
                                        amount={item.amount}
                                        name={
                                            item.moneypool_data
                                                ? item.moneypool_data
                                                      .moneypool_name
                                                : item.cycle_data
                                                ? item.cycle_data.cashbox_name
                                                : ''
                                        }
                                        type={
                                            item.moneypool_data
                                                ? item.moneypool_data.type
                                                : ''
                                        }
                                        date={item.state_time}
                                        destination={item.destination}
                                    />
                                    {/* )} */}
                                </div>
                            ))
                    ) : (
                        <DotsLoading />
                    )}
                </>
            </InfiniteScroll>
        </>
    )
}
